const getCookie = (name: string) => {
  const regexp = new RegExp(`(?:^${name}|; *${name})=(.*?)(?:;|$)`, 'g');
  const result = regexp.exec(document.cookie);
  return result === null ? null : result[1];
};

const getBcId = () => getCookie('BrowserCookieId');

export default { getBcId };
